import { Vms } from '_lib/api';
import { Ivim } from '_store/ivim/ivimsTypes';
import { createEntityAdapter, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PmvReducerState, VmsStatusAlert } from './pmvsTypes';

const initialState: PmvReducerState = {
  loading: false,
  ivimsByVmsId: {},
  ivimsLoadingByVmsId: {},
  statusAlerts: [],
};

export const vmsAdapter = createEntityAdapter({
  selectId: (el: Vms) => el.id,
});

const pmvsReducer = createSlice({
  name: 'pmvs',
  initialState: vmsAdapter.getInitialState(initialState),
  reducers: {
    vmsRequest: (state) => {
      state.loading = true;
    },
    vmsResponse: (state, action: PayloadAction<Vms[]>) => {
      vmsAdapter.setAll(state, action.payload);
      state.loading = false;
    },
    /** Poll refresh: update entities without toggling loading. */
    vmsSilentResponse: (state, action: PayloadAction<Vms[]>) => {
      vmsAdapter.setAll(state, action.payload);
    },
    vmsUpsertOne: vmsAdapter.upsertOne,
    vmsRemove: vmsAdapter.removeOne,
    vmsIvimRequest: (state, action: PayloadAction<string>) => {
      state.ivimsLoadingByVmsId[action.payload] = true;
    },
    vmsIvimResponse: (
      state,
      action: PayloadAction<{ vmsId: string; ivims: Ivim[] }>,
    ) => {
      const { vmsId, ivims } = action.payload;
      state.ivimsByVmsId[vmsId] = ivims;
      state.ivimsLoadingByVmsId[vmsId] = false;
    },
    vmsIvimError: (state, action: PayloadAction<string>) => {
      state.ivimsLoadingByVmsId[action.payload] = false;
    },
    vmsStatusAlertsAdded: (state, action: PayloadAction<VmsStatusAlert[]>) => {
      if (action.payload.length === 0) return;
      const incomingIds = new Set(action.payload.map((alert) => alert.vmsId));
      state.statusAlerts = [
        ...action.payload,
        ...state.statusAlerts.filter((alert) => !incomingIds.has(alert.vmsId)),
      ];
    },
    dismissVmsStatusAlert: (state, action: PayloadAction<string>) => {
      state.statusAlerts = state.statusAlerts.filter((alert) => alert.id !== action.payload);
    },
  },
});

export default pmvsReducer;
